export const parcelsEn = {
  parcels: {
    title: "My Parcels",
    subtitle: "Manage and monitor all your agricultural parcels",
    addParcel: "Add Parcel",
    editParcel: "Edit Parcel",
    deleteParcel: "Delete Parcel",
    parcelName: "Parcel Name",
    cropType: "Crop Type",
    area: "Area",
    location: "Location",
    status: "Status",
    lastAnalysis: "Last Analysis",
    ndviValue: "NDVI Value",
    irrigationStatus: "Irrigation Status",
    healthStatus: "Health Status",
    healthy: "Healthy",
    warning: "Warning",
    critical: "Critical",
    viewDetails: "View Details",
    noParcel: "No parcels found",
    addFirstParcel: "Add your first parcel to get started",
    coordinates: "Coordinates",
    plantingDate: "Planting Date",
    expectedHarvest: "Expected Harvest",
    soilType: "Soil Type"
  },
  parcelsPage: {
    title: "My Parcels",
    titleUrban: "My Green Spaces",
    subtitle: "Manage and monitor your agricultural parcels",
    subtitleUrban: "Manage and monitor your urban green spaces",
    addButton: "Add Parcel",
    addButtonUrban: "Add Green Space",
    addFirst: "Add Your First Parcel",
    addFirstUrban: "Add Your First Green Space",
    emptyTitle: "No Parcels Added",
    emptyTitleUrban: "No Green Spaces Added",
    emptyDesc: "Start by adding your first agricultural parcel to begin monitoring with satellite imagery and weather analysis.",
    emptyDescUrban: "Start by adding your first urban green space to begin monitoring with satellite imagery and environmental analysis.",
    overview: "Overview",
    map: "Map",
    weather: "Weather",
    analytics: "Analytics",
    soil: "Soil",
    policies: "Policies",
    drought: "Drought",
    riskAssessment: "Risk Assessment",
    ndviHealth: "NDVI Health",
    waterStress: "Water Stress",
    temperature: "Temperature",
    humidity: "Humidity",
    precipitation: "Precipitation",
    windSpeed: "Wind Speed",
    analyze: "Analyze",
    analyzing: "Analyzing...",
    analysisCompleted: "Analysis Completed",
    analysisDesc: "Risk assessment and satellite data updated successfully",
    deleteParcel: "Delete",
    deleteConfirm: "Are you sure you want to delete this parcel? This will also delete all related analytics and alerts.",
    parcelDeleted: "Parcel Deleted",
    parcelDeletedDesc: "The parcel and all related data have been successfully deleted.",
    highRisk: "High risk detected",
    moderateRisk: "Moderate risk",
    lowRiskConditions: "Low risk conditions",
    excellentVeg: "Excellent vegetation health",
    goodVeg: "Good vegetation health",
    fairVeg: "Fair vegetation health",
    poorVeg: "Poor vegetation health",
    adequateWater: "Adequate water content",
    moderateWaterStress: "Moderate water stress",
    highWaterStress: "High water stress",
    weatherCard: {
      tempCurrent: "Current",
      tempMean: "Mean",
      tempMeanLabel: "Mean temperature",
      tempTooltip: "Current mean temperature recorded by the nearest weather station.",
      humidityLabel: "Relative humidity (last day)",
      humidityTooltip: "Mean relative humidity (%) — last available daily observation. Source: AEMET (Spain) or Open-Meteo ERA5. \"—\" means the source did not report data.",
      precipLabel: "Precipitation (last observed day)",
      precipNone: "No rain in last day",
      precipRecorded: "Rainfall recorded",
      precipNoData: "No data",
      precipTooltip: "Precipitation reported in the last daily observation (mm) at the nearest station or ERA5 pixel. Does not represent the 7-day accumulated total — see \"Last 7 Days\" below for history. If the source does not report, \"—\" is shown.",
      windLabel: "Wind speed",
      windTooltip: "Mean wind speed (km/h). May not be available with all data sources.",
      sourceAemetTooltip: "Official AEMET data (Spanish State Meteorological Agency)",
      sourceOpenMeteoTooltip: "Open-Meteo ERA5 data (high-quality satellite reanalysis)"
    }
  }
};
